export default __webpack_public_path__ + "static/media/cloudsBg.2c1cf644.svg";